module.exports = __webpack_public_path__ + "static/media/Acuvue_DEFINE_Small_Color_6507-01.1f718965.png";